<template>
    <ShadowBoxContainer>

        <div class="col-sm-9 center pv3 pv4-ns">

            <!-- suggested card -->
            <CardShell>
                <StepProgress :currentStep="1" :totalSteps="11"/>
                <ListHeader
                    :image="require(`@/assets/img/icon_listmytools_step2_information.svg`)"
                    class="ph3 ph4-ns"
                    imageLabel="General Information" heading="What category does this belong to?"
                />
                <HugeSpinner v-if="loadingSuggestedCategories"/>
                <div v-else>
                    <div v-if="suggestedCategories.length > 0">
                    <GreyCategory categoryName="Suggested"/>
                    <CategoryHierachy v-for="(category, index) in suggestedCategories" :key="'s' + index" :categoryHierarchy="category.categoryLevels" @select="selectSuggested(index)" :isSelected="selectedGroup === 0 && selectedIndex === index" />                    
                    </div>
                </div>
            </CardShell>

            <!-- all categories card -->
            <CardShell class="mt3" v-if="allCategories">
                <GreyCategory categoryName="All Categories"/>
                <WhiteCategory v-for="(category, index) in allCategories" :key="'a' + index" :categoryName="category.name" :hasChild="category.children.length > 0" @select="selectAll(index)" :isSelected="selectedGroup === 1 && selectedIndex === index" />
            </CardShell>

        </div>

        <!-- navigation buttons -->
        <template slot="actionBar">
            <NavigationButtons back="Back" forward="Next" :enabledForward="selectedIndex !== null" @backClick="$router.push('/listing-start')" @forwardClick="next" />
        </template>

    </ShadowBoxContainer>
</template>

<script>
import ShadowBoxContainer from '@/components/layout/ShadowBoxContainer.vue';
import CardShell from '@/components/global/CardShell.vue';
import StepProgress from '@/components/controls/StepProgress.vue';
import ListHeader from '@/components/list/shared/ListHeader.vue';
import GreyCategory from '@/components/list/shared/GreyCategory.vue';
import CategoryHierachy from '@/components/list/category/CategoryHierachy.vue';
import WhiteCategory from '@/components/list/shared/WhiteCategory.vue';
import NavigationButtons from '@/components/global/NavigationButtons.vue';
import HugeSpinner from '@/components/controls/HugeSpinner.vue';
import { mapState, mapMutations } from 'vuex';

export default {
    components: {
        ShadowBoxContainer,
        CardShell,
        StepProgress,
        ListHeader,
        GreyCategory,
        CategoryHierachy,
        WhiteCategory,
        NavigationButtons,
        HugeSpinner
    },
    data() {
        return {
            selectedGroup: null,
            selectedIndex: null
        };
    },
    computed: {
        ...mapState('newListing', [
            'suggestedCategories',
            'loadingSuggestedCategories',
            'allCategories'
        ])
    },
    methods: {
        ...mapMutations('newListing', ['setCategoryId']),
        selectSuggested(index) {
            this.selectedGroup = 0;
            this.selectedIndex = index;
        },
        selectAll(index) {
            if (this.allCategories[index].children.length > 0) {
                this.$router.push({
                    path: '/sub-category',
                    query: { index: [index] }
                });
            } else {
                this.selectedGroup = 1;
                this.selectedIndex = index;
            }
        },
        next() {
            var category =
                this.selectedGroup == 0
                    ? this.suggestedCategories[this.selectedIndex]
                          .categoryLevels[
                          this.suggestedCategories[this.selectedIndex]
                              .categoryLevels.length - 1
                      ]
                    : this.allCategories[this.selectedIndex];
            var categoryId = category.id;
            this.setCategoryId(categoryId);
            this.$router.push('/brand');
        }
    }
};
</script>
